<template>
  <div class="task taskButton">
    <button v-on:click="doTask()" v-tooltip="{content: task.info, delay: { show: 400, hide: 100 }, placement: 'bottom'}" type="button" class="w3-buttonTask">
      <transition name="fade" mode="out-in">
        <spinner-loading v-if="taskLoading" class="spinner-loading" :line-size='2' :size='18' line-fg-color='#5dbecd' />
        <i v-else :class="['sherpa-icon', 'icon-' + task.taskId]"></i>
      </transition>
      <span>{{ task.label }}</span>
    </button>
    <div class="message">
      <transition name="fade" mode="out-in">
        <span v-if="!taskLoading && taskError" class="label error_validate"> {{ getLang('taskError') }} </span>
        <span v-else-if="!taskLoading && taskResp && taskResp !== ''" class="label ok_validate"> {{ taskResp }} </span>
      </transition>
    </div>
  </div>
</template>

<script>
import * as api from '../../utils/api'
import SpinnerLoading from 'vue-simple-spinner'
import language from '../../language'

export default {
  name: 'definition-task-button',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'repeatableItemIndex',
    'calledTaskIndex'
  ],
  data () {
    return {
      taskError: false,
      taskResp: '',
      taskLoading: false
    }
  },
  components: {
    SpinnerLoading
  },
  methods: {
    doTask () {
      if (this.task.persist) {
        // Dialog
        let message = this.task.info
        let options = {
          okText: this.$ml.get('yes'),
          cancelText: this.$ml.get('cancel'),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(message, options)
          .then(() => {
            this.callTask()
          })
          .catch(() => {
          })
      } else {
        this.callTask()
      }
    },
    callTask () {
      this.taskLoading = true
      api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode, requestObject: this.object }})
        .then(resp => {
          this.taskError = false
          this.taskLoading = false

          if (this.task.persist) {
            // Dialog
            let message = resp.requestResultSuccess
            let options = {
              okText: this.$ml.get('close'),
              cancelText: null,
              customClass: 'sherpaDialog sherpaDialogOnlyOk'
            }
            this.$dialog.confirm(message, options)
              .then(() => {
                this.doTaskEnd(resp)
              })
              .catch(() => {
                this.doTaskEnd(resp)
              })
          } else {
            this.taskResp = resp.requestResultSuccess
          }
        })
        .catch(err => {
          console.log(err)
          this.taskError = true
          this.taskLoading = false
        })
    },
    getLang (key) {
      return language(this.language, key)
    },
    doTaskEnd (resp) {
      if (this.task.menuId) {
        if (this.$route.name === this.task.menuId) {
          this.$emit('refreshDefinitionContent')
        } else {
          this.$router.push({name: this.task.menuId, params: { id: this.definitionContentId }}).catch(() => {})
        }
      } else if (resp.requestObject) {
        this.$emit('refreshDefinition', resp.requestObject, this.task.scope)
      }
    }
  },
  watch: {
    calledTaskIndex: {
      handler: function (val) {
        this.callTask()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.taskButton {
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskButton.vue